import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { useRouterState } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

const SHOW_DELAY_MS = 120;
const HIDE_DELAY_MS = 150;

const slide = keyframes`
  0% {
    transform: translateX(-100%) scaleX(0.35);
  }
  50% {
    transform: translateX(20%) scaleX(0.55);
  }
  100% {
    transform: translateX(110%) scaleX(0.35);
  }
`;

export const RouterProgressBar = () => {
  const isLoading = useRouterState({ select: (s) => s.isLoading });
  const [phase, setPhase] = useState<'idle' | 'active' | 'fading'>('idle');

  useEffect(() => {
    if (isLoading) {
      const id = setTimeout(() => setPhase('active'), SHOW_DELAY_MS);
      return () => clearTimeout(id);
    }
    if (phase === 'active') {
      setPhase('fading');
      const id = setTimeout(() => setPhase('idle'), HIDE_DELAY_MS);
      return () => clearTimeout(id);
    }
  }, [isLoading, phase]);

  if (phase === 'idle') {
    return null;
  }

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      height="3px"
      // `max`, а не число: полоса перехода обязана быть поверх всего, включая тосты и
      // подсказки. 9999 меньше стокового `max`, поэтому она проигрывала бы любому слою,
      // который берёт ступень по имени.
      zIndex="max"
      pointerEvents="none"
      overflow="hidden"
      opacity={phase === 'active' ? 1 : 0}
      transition="opacity var(--chakra-durations-fast) ease"
      aria-hidden="true"
    >
      <Box
        height="100%"
        width="100%"
        transformOrigin="left"
        background="linear-gradient(90deg, transparent 0%, var(--chakra-colors-purple-500) 30%, var(--chakra-colors-purple-300) 50%, var(--chakra-colors-purple-500) 70%, transparent 100%)"
        boxShadow="glow"
        animation={`${slide} 1.1s ease-in-out infinite`}
      />
    </Box>
  );
};
